import { Chip } from "@mui/material";

import { SelectOption } from "features/Influencer/Tracking/schema";

import styles from "./styles";

interface Props {
  stage: SelectOption;
  sx?: any;
}

const OutreachStatusChip = ({ stage, sx }: Props) => {
  return (
    <Chip
      size="small"
      sx={[
        styles.chip,
        {
          backgroundColor: stage.color,
        },
        sx,
      ]}
      label={stage.name}
    />
  );
};
export default OutreachStatusChip;
